import './../vendors/bootstrap/bootstrap.bundle.min.js';
import * as bootstrap from 'bootstrap';


import pickerForm from "./modules/picker-form.js";
import inputFilter from "./modules/input-filter.js";
import filters from "./modules/filters.js";
import contextMenu from "./modules/context-menu.js";
import connectionMonitor from "./modules/connection-monitor.js";
import sidebar from "./modules/sidebar.js";
import sidebarMenu from "./modules/sidebar-menu.js";
import inventory from './modules/inventory.js';
import productForm from './modules/product-form.js';
import cashOrderForm from "./modules/cash-order-form.js";
import cashOrderRecalculate from "./modules/cash-order-recalculate.js";
import autoTest from './modules/auto-test.js';
import invoicePages from './modules/invoice-pages.js';
import pdfPreview from './modules/pdf-preview.js';

document.addEventListener('DOMContentLoaded', function () {
    window.bootstrap = bootstrap;
    pickerForm.init();
    inputFilter.init();
    filters.init();
    contextMenu.init();
    connectionMonitor.init();
    sidebar.init();
    sidebarMenu.init();
    autoTest.init();
    cashOrderForm.init();
    cashOrderRecalculate.init();
    inventory.init();
    productForm.init();
    invoicePages.init();
    pdfPreview.init();
});
